<template>
  <div>
    <v-dialog
        ref="menuDate"
        :close-on-content-click="false"
        v-model="dialogDate"
        nudge-right="450"
        nudge-bottom="120"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        v-if="!isDisabled">
      <v-date-picker
          v-model="date"
          :value="value"
          :locale="currentLanguage"
          @input="pickDateEvent()"
          @change="ev => updateDateTimeByModel(ev)"
          color="primary"
          class="az-date"/>
    </v-dialog>
    <v-dialog
        ref="menuTimeStart"
        :close-on-content-click="false"
        v-model="dialogDateTimeStart"
        nudge-right="540"
        nudge-bottom="120"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        v-if="!isDisabled">
      <v-card>
        <v-time-picker
            v-if="dialogDateTimeStart"
            v-model="timeStart"
            :locale="currentLanguage"
            color="primary"
            format="24hr"
            class="az-date"/>
        <v-btn color="primary" block tile @click="changeTimeStartEvent(), updateModelTime(timeStart)">Salvar</v-btn>
      </v-card>
    </v-dialog>
    <v-dialog
        ref="menuTimeEnd"
        :close-on-content-click="false"
        v-model="dialogDateTimeEnd"
        nudge-right="540"
        nudge-bottom="120"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        v-if="!isDisabled">
      <v-time-picker
          v-if="dialogDateTimeEnd"
          v-model="timeEnd"
          :locale="currentLanguage"
          @change="changeTimeEndEvent(), updateModelTime($event)"
          format="24hr"
          class="az-date"/>
    </v-dialog>
    <div class="date-input-container">
      <span @click="openMenuDate">{{ dateFormatted }}</span>
      <label @click="openMenuTimeStart" class="container-timed-start">{{ timeStartFormatted }}</label>
      -
      <label style="margin-left: 10px" class="container-timed-end">{{ timeEndFormatted }}</label>
      <div class="container-select-duracao">
        <v-select
            v-model="duracaoEvento"
            :items="duracaoList"
            item-text="text"
            item-value="valor"
            dense
            outlined
            hide-details
            class="ma-2"
            @change="selecionarDuracao"
        ></v-select>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'date-input-evento',
    props: {
        dateFormat: {
            type: String,
            default: 'DD/MM/YYYY',
            validator: function (value) {
                return ['DD/MM/YYYY', 'MM/DD/YYYY'].indexOf(value) !== -1
            }
        },
        value: {
            type: String,
            default: ''
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        nameHour: {
            type: String,
            default: ''
        },
        dataFim: {
            type: String,
            required: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
    },
    inject: ['$validator'],
    data() {
        return {
            date: null,
            dateFormatted: null,
            dateInvalid: false,
            timeStart: null,
            timeEnd: null,
            timeStartFormatted: null,
            timeEndFormatted: null,
            dialogDate: false,
            dialogDateTimeStart: false,
            dialogDateTimeEnd: false,
            reverseDateFormatObj: {
                'DD/MM/YYYY': 'YYYY-MM-DD',
                'MM/DD/YYYY': 'YYYY-DD-MM'
            },
            duracaoList: [
                {text: '10 minutos', valor: 10},
                {text: '15 minutos', valor: 15},
                {text: '30 minutos', valor: 30},
                {text: '1 hora', valor: 60},
                {text: '2 horas', valor: 120},
            ],
            duracaoEvento: 30,
        }
    },
    computed: {
        reverseDateFormat() {
            return this.reverseDateFormatObj[this.dateFormat]
        },
        currentLanguage() {
            return this.$vuetify.lang.current
        },
        validateDate() {
            const validationDate = {}
            if (this.isRequired) {
                validationDate.required = true
            }

            if (this.dateFormatted && this.dateFormatted.length === 10) {
                validationDate.date_format = this.dateFormat === 'DD/MM/YYYY' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'
            }
            return validationDate
        }
    },
    mounted() {
        this.alterTabIndexFromAppendButtons()
        this.updateValue(this.value)
        this.setarDataFim()
    },
    methods: {
        formatDate(date) {
            if (!date) return null
            return moment(date).format('dddd, DD [de] MMMM')
        },
        changeTimeStartEvent() {
            this.timeStartFormatted = this.timeStart
            this.$refs.menuTimeStart.save(this.timeStart)
        },
        changeTimeEndEvent() {
            this.timeEndFormatted = this.timeEnd
            this.$refs.menuTimeEnd.save(this.timeEnd)
        },
        pickDateEvent() {
            this.dialogDate = false
        },
        openMenuDate() {
            this.dialogDate = true
        },
        openMenuTimeStart() {
            this.dialogDateTimeStart = true
        },
        openMenuTimeEnd() {
            this.dialogDateTimeEnd = true
        },
        updateModelTime(value) {
            if (this.date && value) {
                const dateTimeWithTimezone = this.buildDateTimeWithTimezone(this.date, value)
                const dateTimeTimezoneZero = this.getDateTimeZeroTimezone(dateTimeWithTimezone)
                this.updateValue(dateTimeTimezoneZero)
                return
            }
            if (this.date && !value) this.$emit('atualizarData', this.date)
        },
        updateDateTimeByModel(modelVal) {
            const dateModelLength = 10
            const dateTime = this.buildDateTimeWithTimezone(modelVal, this.timeStart)
            if (modelVal.length === dateModelLength) {
                this.date = modelVal
                this.dateFormatted = this.formatDate(modelVal)
            }
            this.updateValue(dateTime)
        },
        getDateTimeWithSystemTimezone(dateTime) {
            const offset = this.getOffsetFromCurrentDateTime(dateTime)
            return this.moment(dateTime)
                .utcOffset(offset)
                .format(this.reverseDateFormat + 'THH:mm:ss.SSSZZ')
        },
        getDateTimeZeroTimezone(dateTime) {
            const offset = this.getOffsetFromCurrentDateTime(dateTime)
            return this.moment(dateTime)
                .utcOffset(offset)
                .format(this.reverseDateFormat + 'THH:mm:ss.SSSZZ')
        },
        buildDateTimeWithTimezone(date, time) {
            const seconds = '00'
            const dateTime = date + 'T' + time + ':' + seconds
            const offset = this.getOffsetFromCurrentDateTime(dateTime)
            return dateTime + offset
        },
        getOffsetFromCurrentDateTime(dateTime) {
            return this.moment(dateTime)
                .tz(this.$store.state.comum.timezone)
                .format('Z')
        },
        selectContentInputHour() {
            this.$nextTick(() => {
                const input = document.getElementsByName(this.nameHour)[0]
                if (input) {
                    input.setSelectionRange(0, 5)
                }
            })
        },
        setarDataFim() {
            if (this.dataFim) {
                this.duracaoEvento = moment(this.dataFim).diff(this.value, 'minutes')
                this.timeEnd = moment(this.dataFim).format('HH:mm')
                this.timeEndFormatted = this.timeEnd
            }
        },
        updateValue(val) {
            if (val) {
                const dateTimeStart = this.getDateTimeWithSystemTimezone(val)
                const dateTimeEnd = moment(dateTimeStart).add(this.duracaoEvento, 'm')
                const splitDateTime = dateTimeStart.split('T')
                this.date = splitDateTime[0]
                this.dateFormatted = this.formatDate(this.date)
                this.timeStart = splitDateTime[1].substring(0, 5)
                this.timeStartFormatted = this.timeStart
                this.timeEnd = moment(dateTimeEnd).format('HH:mm')
                this.timeEndFormatted = this.timeEnd
                this.$emit('atualizarData', val)
            }
        },
        alterTabIndexFromAppendButtons() {
            const bottonsDate = document.querySelectorAll('.az-date-date-input .v-input__append-inner .v-icon')
            bottonsDate.forEach(btn => {
                btn.tabIndex = '-1'
            })
            const bottonsTime = document.querySelectorAll('.az-date-time-input .v-input__append-inner .v-icon')
            bottonsTime.forEach(btn => {
                btn.tabIndex = '-1'
            })
        },
        selecionarDuracao() {
            const data = this.buildDateTimeWithTimezone(this.date, this.timeStart)
            this.updateValue(data)
            this.$emit('selecionarDuracao', this.duracaoEvento)
        }
    }
}
</script>

<style scoped lang="stylus">

.date-input-container
  font-size 16px
  display flex
  align-items center

  span, .container-timed-start
    background-color #eceff3
    padding 10px
    border-radius 5px

.container-timed-start
  margin 0 10px

.date-input-container >>> span:hover, .container-timed-start:hover
  cursor pointer
  background-color #DDE3E9

.container-timed-end
  background-color #e0e0e0
  padding 10px
  border-radius 5px

.container-timed-end:hover
  cursor not-allowed

.container-select-duracao
  width 170px

.az-date
  .v-picker__title
    padding 10px 15px

  .v-date-picker-title__date
    font-size 20px

  .v-time-picker-title__time .v-picker__title__btn, .v-time-picker-title__time span
    font-size 40px
    height 50px

  .v-time-picker-title
    -webkit-box-pack center
    -ms-flex-pack center
    justify-content center
</style>